<template>
  <div class="expenditure-income">
    <header>
      <div class="content-top">
        <!-- 时间选项 -->
        <div class="date-option" @click="showPopup">
          <span>
            {{search_time}}<img src="../../assets/images/partner-img/partner-information/16.png" alt="">
          </span>
        </div>
        <p class="statistics">
          新增总额:{{brokerage_list.schedule_nu}}
        </p>
        <p class="statistics">
          分成总额:{{brokerage_list.all_nu}}
        </p>
        <p class="all_money">
          总合计:{{brokerage_list.aggregate}}
        </p>
      </div>
    </header>
    <section>
      <div class="share-option-list" v-for="(item,index) in brokerage_list.info" :key="index">
        <div class="share-option-list-content">
          <div class="touxiang">
            <img :src="item.avatar" alt="">
          </div> 
          <div class="msg1">
            <span>
              {{item.fans_name}}
            </span>
            <span>
              {{item.create_time}}
            </span>
          </div>
          <div class="msg2">
            <span>
              +{{item.brokerage}}
            </span>
            <span>
              <!-- 二级佣金 -->
            </span>
          </div>
        </div>
      </div>
    </section>
    <van-popup v-model="show"  position="bottom" :style="{ height: '40%' }" >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="show = false"
        @confirm="confirm_btn"
      />
    </van-popup>
  </div>
</template>

<script>

import Vue from 'vue';
import { DatetimePicker, Popup } from 'vant';

Vue.use(DatetimePicker);
Vue.use(Popup);

export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      brokerage_list: [], // 佣金列表
      search_time: '本月', // 选择时间,
      post_search_time: '', // 时间筛选
    };
  },
  created(){
    // 佣金
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/brokerage/index/new_brokeragelog",{
      uid : this.uid,
      type : 2
    }).then((res) => {
      // console.log(res.data.data)
      this.brokerage_list = res.data.data
    })
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    showPopup(){
      this.show = true
    },
    // 选择时间筛选
    confirm_btn(){
      this.search_time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      this.post_search_time = this.currentDate.getFullYear() + '-' + (this.currentDate.getMonth() + 1)
      this.$axios.post(this.domain.url+"/api/brokerage/index/new_brokeragelog",{
        uid : this.uid,
        type : 2,
        search_time : this.post_search_time
      }).then((res) => {
        // console.log(res.data.data)
        this.brokerage_list = res.data.data
      })
      this.show = false
    }
  },
}
</script>

<style lang="less" scoped>
  .expenditure-income{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background: #f4f4f4;
    header{
      .content-top{
        width: 7.5rem;
        height: 1.29rem;
        overflow: hidden;
        line-height: 1.29rem;
        .date-option{
          background: #fff;
          border-radius: .24rem;
          margin-top: .4rem;
          margin-left: .2rem;
          float: left;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #212121;
          text-align: center;
          line-height: .26rem;
          padding: .12rem .12rem .12rem .21rem;
          img{
            width: .07rem;
            height: .05rem;
            margin-bottom: .1rem;
            margin-left: .1rem;
          }
        }
        .statistics{
          float: left;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #222222;
          margin-left: .2rem;
        }
        .all_money{
          float: right;
          margin-right: .21rem;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #222222;
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        display: flex;
        align-items: center;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.68rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          .touxiang{
            width: .94rem;
            height: 1.68rem;
            float: left;
            margin-right: .1rem;
            display: flex;
            align-items: center;
            img{
              width: .94rem;
              height: .94rem;
              border-radius: 50%;
            }
          }
          .msg1{
            float: left;
            span{
              display: block;
              &:first-child{
                font-size: 0.3rem;
                line-height: .3rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #222222;
                margin-top: .46rem;
              }
              &:last-child{
                font-size: 0.24rem;
                line-height: .24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #919191;
                margin-top: .18rem;
              }
            }
          }
          .msg2{
            float: right;
            span{
              display: block;
              &:first-child{
                font-size: 0.36rem;
                line-height: .36rem;
                font-family: PingFang SC;
                font-weight: bold;
                color: #FF6600;
                margin-top: .5rem;
              }
              &:last-child{
                font-size: 0.2rem;
                line-height: .2rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FF6600;
                margin-top: .1rem;
              }
            }
          }
        }
      }
    }
  }
</style>